/** @format */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { PlanValidationResult, ValidatablePlan } from 'common-typescript';
import { Module, StudyRight } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { finalize } from 'rxjs/operators';
import { AppErrorHandler } from 'sis-components';
import { ModuleAttainmentApplicationService } from '../../../../service/module-attainment-application.service';

@Component({
    selector: 'app-student-module-info-modal-create-module-attainment-application-block',
    templateUrl: './student-module-info-modal-create-module-attainment-application-block.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StudentModuleInfoModalCreateModuleAttainmentApplicationBlockComponent implements OnInit {
    attainmentApplicationSendPending = false;
    mode: 'FLAT' | 'RECURSIVE' | 'ACTIVE_STUDY_RIGHT_NOT_FOUND';

    @Input() module: Module;
    @Input() validatablePlan: ValidatablePlan;
    @Input() planValidationResult: PlanValidationResult;
    @Input() studyRight: StudyRight;
    @Output() refreshData = new EventEmitter<void>();

    constructor(
        private moduleAttainmentApplicationService: ModuleAttainmentApplicationService,
        private appErrorHandler: AppErrorHandler,
    ) {}

    ngOnInit() {
        this.mode = this.getMode();
    }

    getMode() {
        if (!this.studyRight || this.studyRight.state !== 'ACTIVE') {
            return 'ACTIVE_STUDY_RIGHT_NOT_FOUND';
        }
        const childModules = this.validatablePlan.getSelectedModulesUnderModule(this.module);
        if (!_.isEmpty(childModules)) {
            return 'RECURSIVE';
        }
        return 'FLAT';
    }

    applyForModuleAttainment() {
        this.attainmentApplicationSendPending = true;
        this.moduleAttainmentApplicationService
            .sendApplication(
                this.module,
                this.validatablePlan,
                this.studyRight,
                this.planValidationResult,
                false,
                this.appErrorHandler.defaultErrorHandlerFd(),
            )
            .pipe(
                this.appErrorHandler.defaultErrorHandlerFd(),
                finalize(() => (this.attainmentApplicationSendPending = false)),
            )
            .subscribe(() => {
                this.refreshData.emit();
            });
    }
}
